import * as React from "react";
import {useDispatch} from "react-redux";
import {isEmpty} from "weed-js";

import Loading from "../../../components/elements/Loading";
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {FacilityETL} from "./FacilityETL";
import "./style.css";


const FacilityETLs = ({
    loggedInUser,
    integrationNamespace,
    integrationAccount,
    facility,
    etls,
    facilityETLs,
    currentUsage,
    isActive
}) => {
    const dispatch = useDispatch();

    if(isEmpty(etls) || isEmpty(facilityETLs)) {
        return <Loading/>;
    }

    return <TableContainer className={"facilty-etl-table-container"}>
        <Table className={"facility-etl-table"}>
            <TableHead>
                <TableRow>
                    <TableCell>ETL Name</TableCell>
                    <TableCell>Maximum Monthly Calls</TableCell>
                    <TableCell>Enabled</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Current Cost this Month</TableCell>
                    <TableCell>MAXIMUM Estimated Monthly Cost</TableCell>
                    <TableCell>Sync Data</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {facilityETLs.map(facilityETL => {
                    const etl = etls.find(e => e.id === facilityETL.etl_id);
                    return <FacilityETL
                        loggedInUser={loggedInUser}
                        key={"facility-etl-" + facilityETL.id}
                        integrationNamespace={integrationNamespace}
                        facility={facility}
                        facilityETL={facilityETL}
                        etl={etl}
                        currentUsage={currentUsage.filter(usage => usage.etl_id === facilityETL.etl_id && usage.facility_id === facilityETL.facility_id) || []}
                        isActive={isActive}
                        integrationAccount={integrationAccount}
                    />;
                })}
            </TableBody>
        </Table>
    </TableContainer>;
};

export default FacilityETLs;